/**
 * AiCreateButton - "Create account from screenshot / text" next to "Add
 * Account" (mode 'accounts') and "Create opportunity from screenshot / text"
 * next to "+ New Opportunity" (mode 'opportunities'). Two separate tools
 * (aiCreateModel MODES): each is shown only to someone with Edit on its own
 * area, and opens AiCreateModal with only its own cards.
 */
import { useState } from 'react';
import { canEdit } from '../../data/roles';
import { useMyAccess } from '../../hooks/useMyAccess';
import AiCreateModal from './AiCreateModal';
import { aiCreateRights, MODES } from './aiCreateModel';

export default function AiCreateButton({ mode = 'accounts', style }) {
  const access = useMyAccess();
  const rights = aiCreateRights(canEdit(access, 'accounts'), canEdit(access, 'opportunities'), mode);
  const [open, setOpen] = useState(false);
  if (!rights.any) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title={MODES[mode].intro}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          padding: '6px 14px',
          borderRadius: 6,
          border: '1px solid #1B5E20',
          background: '#fff',
          color: '#1B5E20',
          fontSize: 11,
          fontWeight: 700,
          cursor: 'pointer',
          fontFamily: 'Montserrat',
          whiteSpace: 'nowrap',
          ...style,
        }}
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" />
          <path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z" />
        </svg>
        {MODES[mode].button}
      </button>
      {open && <AiCreateModal mode={mode} rights={rights} onClose={() => setOpen(false)} />}
    </>
  );
}
